module.exports = __webpack_public_path__ + "img/dark-triangle-left.6022cd2c.svg";